<div class="chat-link">
  <div class="head">
    <div>
      <h3 *ngIf="data.links.length === 1">
        {{ nameOf(people(link)[0].uid) }} and {{ nameOf(people(link)[1].uid) }}
      </h3>
      <h3 *ngIf="data.links.length > 1">{{ data.links.length }} chats on this line</h3>
      <p class="sub">One-to-one chat between two members</p>
    </div>
    <button mat-icon-button (click)="close()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <ul class="pairs" *ngIf="data.links.length > 1" role="listbox" aria-label="Chats on this line">
    <li
      *ngFor="let l of data.links; let i = index"
      role="option"
      [attr.aria-selected]="i === selected"
      [class.on]="i === selected"
      (click)="select(i)"
      (keydown.enter)="select(i)"
      tabindex="0"
    >
      <span class="pair-names">{{ nameOf(people(l)[0].uid) }} → {{ nameOf(people(l)[1].uid) }}</span>
      <span class="pair-meta">{{ l.messages }} msg · {{ ago(l.lastMessageAt) }}</span>
    </li>
  </ul>

  <div class="people">
    <ng-container *ngFor="let p of people(link); let i = index; trackBy: trackByUid">
      <div class="arrow" *ngIf="i === 1" aria-hidden="true">
        <mat-icon>east</mat-icon>
      </div>
      <div class="person">
        <app-user-image
          [imgSrc]="p.member?.photo"
          [userId]="p.uid"
          [width]="64"
          [height]="64"
          [isAvatar]="true"
        ></app-user-image>
        <div class="who">
          <app-person-link
            [uid]="p.uid"
            [name]="p.name"
            [big]="true"
            (failed)="profileError = $event"
          ></app-person-link>
          <span class="line" *ngIf="work(p.member)">{{ work(p.member) }}</span>
          <span class="line muted" *ngIf="p.member?.city">{{ p.member?.city }}</span>
          <span class="tags">
            <span class="tag" *ngIf="p.started">Started it</span>
            <span class="tag new" *ngIf="isNew(p.member)">New</span>
            <span class="muted" *ngIf="seen(p.member)">{{ seen(p.member) }}</span>
          </span>
          <span class="wrote">
            <b>{{ p.wrote }}</b> message{{ p.wrote === 1 ? '' : 's' }} written
          </span>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="notice bad" *ngIf="profileError" role="alert">{{ profileError }}</div>

  <div class="stats">
    <div class="stat"><span>Messages</span><b>{{ link.messages }}</b></div>
    <div class="stat"><span>Back and forth</span><b>{{ link.turns }}</b></div>
    <div class="stat"><span>First message</span><b>{{ date(link.firstMessageAt) }}</b></div>
    <div class="stat"><span>Last message</span><b>{{ ago(link.lastMessageAt) }}</b></div>
  </div>

  <div class="loading" *ngIf="loading"><mat-spinner diameter="24"></mat-spinner></div>
  <div class="notice bad" *ngIf="error">{{ error }}</div>

  <ng-container *ngIf="!loading && conversations(link) as convs">
    <ul class="convs">
      <li *ngFor="let c of convs">
        <span class="pill" [ngClass]="c.state">{{ stateLabel(c.state) }}</span>
        <span class="pill bad" *ngIf="c.blocked">Blocked</span>
        <span class="muted">
          {{ c.messages }} message{{ c.messages === 1 ? '' : 's' }}
          <ng-container *ngIf="c.reactions"> · {{ c.reactions }} reaction{{ c.reactions === 1 ? '' : 's' }}</ng-container>
          · {{ date(c.firstMessageAt) }} to {{ date(c.lastMessageAt) }}
        </span>
      </li>
    </ul>
    <p class="muted" *ngIf="convs.length > 1">
      These two have {{ convs.length }} separate chats, for example after a block or a reinstall.
    </p>
  </ng-container>

  <div class="actions">
    <p class="muted note">Who and when only. No message is read, here or on the server.</p>
    <button mat-flat-button color="primary" (click)="showOnMap()">
      <mat-icon>my_location</mat-icon>
      Show both on the map
    </button>
  </div>
</div>
